import PagesServices from "../../services/PagesServices";
import { buildPagesConfigExecutePayload, getPagesConfigExecuteUrl, evaluatePagesMessageCondition, resolveAndNavigateRedirect, isToPageRedirectMode } from "../../Containers/PagesContainer/PagesContainerUtils";
import { isSet, conditionRulesChecking } from "../../Utils/CommonFunctions";
import { getGoBackURL, setGoBackURL } from "../../Utils/UserFunctions";
import http from "../../services/http";
import { 
  SET_FROM_MAPPING,
  SET_RESOURCES_LIST,
  UPDATE_FROM_MAPPING_FIELDS,
  REMOVE_FROM_MAPPING_FIELD,
  SET_TO_PAGES,
  SET_TO_MAPPING,
  UPDATE_TO_MAPPING_FIELDS,
  REMOVE_TO_MAPPING_FIELD,
  SET_TO_PAGE_CONDITION,
  CLEAR_PAGES_CONFIG,
  REMOVE_TO_PAGES,
  LOAD_CONFIG_COLLECTION,
  LOAD_CONFIG_COLLECTION_SILENT,
  SET_ACTIVE_CONFIG_PAGE,
  REMOVE_ACTIVE_POPUP_PAGE,
  SET_RESOURCES_LIST_BY_TYPE,
  UPDATE_PAGE_FLOWS_DATA,
  RESTORE_PAGE_FLOWS,
  SET_HISTORY_PAGE_FLOWS,
  GO_TO_HISTORY_PAGE_FLOWS,
  CLEAR_HISTORY_PAGE_FLOWS,
  UPDATE_PAGE_DATA_BY_KEY,
  REMOVE_HISTORY_PAGE_BY_KEY,
  SET_WINDOW_VARIABLE_LIST,
  UPDATE_TO_PAGE
} from "../actionTypes/PagesActionTypes";
import { failMessage } from "./CommonActions";
//SET SHIPPING DETAILS PAYLOAD
export const setFromMappingPayloadAction = (payload) => {
    return { 
      type: SET_FROM_MAPPING, 
      payload:payload
    };
  };

export const setToMappingPayloadAction = (pageIndex,newFieldMappings)=>{
  return{
    type:SET_TO_MAPPING,
    payload:{
      pageIndex,
      newFieldMappings
    }
  }
}

export const setResourcesListAction = (payload) =>{
  return{
    type:SET_RESOURCES_LIST,
    payload:payload
  }
}

export const setResourcesListByTypesAction = (inputs,outputs)=>{
  return{
    type:SET_RESOURCES_LIST_BY_TYPE,
    payload:{
      inputsVar:inputs,
      outputsVar:outputs
    }
  }
}
export const updateFromMappingFieldsAction = (index,value)=>{
  return{
    type:UPDATE_FROM_MAPPING_FIELDS,
    payload:{
      fromIndex:index,
      fromValue:value
    }
  }
}


export const updateToMappingFieldsAction = (pageIndex,index,value)=>{
  return{
    type:UPDATE_TO_MAPPING_FIELDS,
    payload:{
      pageIndex,pageIndex,
      toIndex:index,
      toValue:value
    }
  }
}

export const removeFromMappingFieldAction =(index)=>{
  return{
    type:REMOVE_FROM_MAPPING_FIELD,
    payload:{
      fromRemoveIndex:index
    }
  }
}


export const removeToMappingFieldAction = (pageIndex,index)=>{
  return{
    type:REMOVE_TO_MAPPING_FIELD,
    payload:{
      pageIndex:pageIndex,
      toRemoveIndex:index
    }
  }
}


export const setToPagesAction =(payload)=>{
  return{
    type: SET_TO_PAGES,
    payload:payload
  }
}

export const removeToPagesAction = (toPageIndex)=>{
  return{
    type:REMOVE_TO_PAGES,
    payload:{
      toPageIndex
    }
  }
}
  
export const setToPagesCondition = (pageIndex,condition)=>{
  return{
    type:SET_TO_PAGE_CONDITION,
    payload:{
      pageIndex,
      condition
    }
  }
}

export const updateToPageAction = (pageIndex, patch) => ({
  type: UPDATE_TO_PAGE,
  payload: { pageIndex, patch }
});

export const clearPagesConfiguration = ()=>{
  return{
    type:CLEAR_PAGES_CONFIG
  }
}

export const setPagesHistoryConfigAction = ()=>{
  return {
    type:SET_HISTORY_PAGE_FLOWS,

  }
}
export const removeHistoryPageByKeyAction = (configKey)=>{
  return {
    type: REMOVE_HISTORY_PAGE_BY_KEY,
    payload:{ configKey }
  }
}

export const setWindowVariableListAction = (windowVariableList) => {
  return {
    type: SET_WINDOW_VARIABLE_LIST,
    payload: { windowVariableList }
  };
};

export const goToHistoryPageAction  =()=>{
  return{
    type:GO_TO_HISTORY_PAGE_FLOWS
  }
}

export const clearHistoryPageFlowsAction = () => {
  return {
    type: CLEAR_HISTORY_PAGE_FLOWS,
  };
};

const trySamePageResponseUpdate = (isSamePage, configApiName, toFieldMapping, params, dispatch, getState) => {
  if (!isSamePage || typeof getState !== 'function' || !configApiName) {
    return false;
  }
  const safeParams =
    params && typeof params === 'object' && !Array.isArray(params) ? params : {};
  const existingPages = getState()?.PagesReducer?.pageFlows?.pageData?.[configApiName]?.pages;
  if (!existingPages?.html) {
    return false;
  }
  loaderDispatch(dispatch, false);
  dispatch(updatePageDataByKeyAction(configApiName, 'pages', {
    ...existingPages,
    params: safeParams,
    response: toFieldMapping
  }));
  return true;
};

// Helper function to fetch page details and handle navigation (extracted from PagesRenderComponent)
const fetchPageDetails = (pageId, configApiName, toFieldMapping, dispatch, history, currentPage = null, pageType = null, params = {}, isSamePage = false, getState = null) => {
  if (trySamePageResponseUpdate(isSamePage, configApiName, toFieldMapping, params, dispatch, getState)) {
    return;
  }
  const searchParams = new URLSearchParams(window.location.search);
  const isPublic = searchParams.get('public') === 'true';
  const domainName = searchParams.get('domain') || 'apps.myship.ca';
  const publicQuery = isPublic
    ? `?public=true&domain=${encodeURIComponent(domainName)}`
    : '';
  const publicQuerySuffix = publicQuery ? `&${publicQuery.slice(1)}` : '';
  const pageDetailsUrl = isPublic && configApiName
    ? `public-pages/${domainName}/${configApiName}/pages/search-by-id/${pageId}`
    : `pages/search-by-id/${pageId}`;

  http.GET(pageDetailsUrl)
    .then(async (res) => {
      dispatch({ type: "LOADER", bool: false });
      if (res.status === 200) {
        const response = res.data;
        if (response.code === 200) {
          console.log('response?.data', response?.data);
          const resData = response?.data;
          const targetConfigKey = resData?.configuration_api_name || configApiName || pageId;
          const safeParams =
            params && typeof params === "object" && !Array.isArray(params) ? params : {};
          let shouldNavigateSameWindow = false;
          if (resData?.display_type === 'SAME_WINDOW') {
            if (!isSamePage) {
              dispatch(setPagesHistoryConfigAction());
            }
            shouldNavigateSameWindow = true;
            if (pageType === 'POPUP' && currentPage) {
              dispatch(removeActivePopupPageAction(currentPage));
            }
          } else if (resData?.display_type === 'SEPARATE_WINDOW') {
            const url = `/pages/${targetConfigKey}?mode=window${publicQuerySuffix}`;
            const { format, width, height } = resData;
            let screenwidth;
            let screenheight;
            let topPosition = 100;
            let leftPosition = 100;

            if (format === "CUSTOM") {
              screenwidth = width;
              screenheight = height;
            } else {
              screenwidth = window.screen.availWidth;
              screenheight = window.screen.availHeight;
            }

            if (window.opener) { window.close(); }
            const windowFeature = `width=${screenwidth},height=${screenheight},top=${topPosition},left=${leftPosition},resizable=no,scrollbars=yes,location=no,status=no`;

            const forceResize = (win) => {
              if (!win.closed) {
                win.resizeTo(screenwidth, screenheight);
                win.focus();
              }
            };

            if (window.childWindow && !window.childWindow.closed) {
              window.childWindow.location.href = url;
              forceResize(window.childWindow);
            } else {
              //Open new window
              window.childWindow = window.open(
                url,
                resData.page_name,
                windowFeature
              );
            }
            dispatch(setPagesHistoryConfigAction());
          } else {
            if (currentPage) {
              dispatch(removeActivePopupPageAction(currentPage));
            }
          }
          const pagesPayload = {
            ...response?.data,
            params: safeParams,
            response: toFieldMapping
          };
          dispatch(loadPageConfigCollectionAction({
            pages: pagesPayload,
            type: 'PAGES',
          }, 'ID', targetConfigKey));//response?.data.id
          queueMicrotask(() => {
            
            dispatch(updatePageDataByKeyAction(targetConfigKey, 'pages', {
              ...pagesPayload
            }));
          });
          if (shouldNavigateSameWindow === true && history) {
            const targetPath = `/pages/${targetConfigKey}${publicQuery}`;
            if (history.location?.pathname !== targetPath) {
              history.push(targetPath);
            }
          }
        } else {
          // Handle error case if needed
        }
      }
    }, (error) => {
      dispatch({ type: "LOADER", bool: false });
      console.error('Error fetching page details:', error);
    });
};

// RENDER PAGES BLOCK


export const loadPagesConfigAction = (searchBy, configId, options = {}) => {
  return async (dispatch, getState) => {
    const { history, onload = false, pType = 'DEFAULT', action = null, obj = null, params = null } = options || {};
    const current = window.location?.pathname;
    const searchParams = new URLSearchParams(window.location.search);
    const publicQuery = searchParams.get('public') === 'true'
      ? `?public=true&domain=${encodeURIComponent(searchParams.get('domain') || 'apps.myship.ca')}`
      : '';
    const publicQuerySuffix = publicQuery ? `&${publicQuery.slice(1)}` : '';
    const urls = getGoBackURL?.() || [];

    if (current && urls.length === 0) {
      setGoBackURL(current);
    }

    const getStates = getState();
    const configs = isSet(getStates?.PagesReducer?.pageFlows?.pageData?.[configId], null);

    // If this is an onload-only call and we already have page data cached for this key,
    // skip the API call and rely on existing state.
    // if (onload === true){
    //   console.log('configs',configs);
    // }
   
    // if (onload === true && configs && typeof configs === "object" && Object.keys(configs).length > 0) {
    //   return;
    // }
    if (onload === false) {
      loaderDispatch(dispatch, true);
    }
    let response;
    //API_NAME
    try {
      if(searchBy === 'ID'){
        response = await PagesServices.getConfigById(configId);
      }else{
        response = await PagesServices.getConfigByName(configId);
      }
      loaderDispatch(dispatch,false);
      if(response?.code===200 && response?.data){
        const responseData = response?.data;    
        let outputVariables = {};    
        console.log('responseData-data..',responseData,pType,onload,params);    
        if(responseData?.config_type==="DIRECT"){
          try{
          //   const postData = {
          //     actionComponentId: action?.id,
          //     layoutId: obj?.layoutId,
          //     windowId: obj?.windowId,
          //     ids: obj?.val
          //   }
          // let directResponse = obj!=null ? await PagesServices.getConfigDirect(configId, postData) : null;
          //   if(obj?.isPagesHyperLink===true){
          //     const postData = {
          //       hyperlink_field_id: obj?.table_descriptor_id,
          //       record_id: obj?.record_id,
          //       layoutId: obj?.layoutId,
          //       windowId: obj?.windowId,
          //       ids: obj?.val
          //       }
          //     directResponse = await PagesServices.getConfigDirectHyperLink(configId, postData);
          //   }else{
          //     const postData = {
          //     actionComponentId: action?.id,
          //     layoutId: obj?.layoutId,
          //     windowId: obj?.windowId,
          //     ids: obj?.val
          //   }
          //   // console.log('postData',postData);
          //     directResponse = obj!=null ? await PagesServices.getConfigDirect(configId, postData) : null;
          // }
          
          // // Transform the directResponse to outputVariables format
          // if (directResponse && directResponse.data) {
          //   Object.keys(directResponse.data).forEach((uuidKey) => {
          //     const variableArray = directResponse.data[uuidKey];
          //     if (Array.isArray(variableArray)) {
          //       variableArray.forEach((variable) => {
          //         if (variable.variable_name) {
          //           outputVariables[variable.variable_name] =
          //             variable.selected_value ?? variable.value;
          //         }
          //       });
          //     }
          //   });
          // }
          //   if (Object.keys(outputVariables).length > 0) {
          //     const dataToStoreForChildOutput = {
          //       pageId: responseData?.id,
          //       outputResponse: outputVariables
          //     };
          //     localStorage.setItem('directApiOutputForChildWindow', JSON.stringify(dataToStoreForChildOutput));
          //   }
          //   if (obj === null && Object.keys(outputVariables).length === 0) {
          //     const storedOutputStr = localStorage.getItem('directApiOutputForChildWindow');
          //     if (storedOutputStr) {
          //       try {
          //         const storedOutputData = JSON.parse(storedOutputStr);
          //         if (storedOutputData.pageId === responseData?.id) {
          //           outputVariables = storedOutputData.outputResponse;
          //         }
          //         localStorage.removeItem('directApiOutputForChildWindow');
          //       } catch (parseError) {
          //         console.error("Error parsing stored directApiOutputForChildWindow:", parseError);
          //         localStorage.removeItem('directApiOutputForChildWindow');
          //       }
          //     }
          //   }
        }catch(error){
          console.log('error',error);
        }
            const pages = responseData?.pages;
            let shouldNavigateSameWindow = false;
            if(pages?.display_type==='SAME_WINDOW' && onload===false){
              // Track same-window navigation in pages history
              dispatch(setPagesHistoryConfigAction());
              shouldNavigateSameWindow = true;
            }else if(pages?.display_type==='SEPARATE_WINDOW' && onload===false){
                const url = `/pages/${responseData?.configuration_api_name}?mode=window${publicQuerySuffix}`;
              const { format, width, height } = pages;
              let screenwidth;
              let screenheight;
              let topPosition = 100;
              let leftPosition = 100;

              if (format === "CUSTOM") {
                screenwidth = width;
                screenheight = height;
              } else {
                screenwidth = window.screen.availWidth;
                screenheight = window.screen.availHeight;
              }

              if (window.opener) { window.close(); }
              const windowFeature = `width=${screenwidth},height=${screenheight},top=${topPosition},left=${leftPosition},resizable=no,scrollbars=yes,location=no,status=no`;

              const forceResize = (win) => {
                // setTimeout(() => {
                  if (!win.closed) {
                    win.resizeTo(screenwidth, screenheight);
                    // win.moveTo(leftPosition, topPosition);
                    win.focus();
                  }
                // }, 10);
              };

              if (window.childWindow && !window.childWindow.closed) {
                window.childWindow.location.href = url;
                forceResize(window.childWindow);
              } else {
                //Open new window
                window.childWindow = window.open(
                  url,
                  pages.page_name,
                  windowFeature
                );
                //Force resize/reposition
                // if (window.childWindow) {
                //   forceResize(window.childWindow);
                // }
              }

                // const {format,width,height} = pages;
                // let screenwidth =null;//window.screen.availWidth; //null;// 800;
                // let screenheight = null;//window.screen.availHeight;// 600;
                // if(format==="CUSTOM"){
                //   screenwidth = width;
                //   screenheight = height;
                // }
                // else{
                //   // screenwidth=window.screen.availWidth;
                //   // screenheight =window.screen.availHeight;// 600;
                // }
                // if(window.opener){window.close();}
                // // console.log('pages',pages);
                // const windowFeature= `width=${screenwidth},height=${screenheight},top=100,left=100,resizable=no,scrollbars=yes,location=no,status=no`;
                // if (window.childWindow && !window.childWindow.closed) {
                //   window.childWindow.location.href = url; // reload the new URL
                //   window.childWindow.resizeTo(screenwidth, screenheight);
                //   // window.childWindow.moveTo(100, 100);
                //   window.childWindow.focus();
                // } else {
                  
                //   window.childWindow = window.open(
                //     url,
                //     pages.page_name, // window name
                //    windowFeature
                //   );
                // }



                // const childWindow = window.open(
                //     url,
                //     pages.page_name, // window name
                //     `width=${screenwidth},height=${screenheight},top=100,left=100,resizable=no,scrollbars=yes,location=no,status=no`
                // );
                // -------------------------
                //  childWindow.sharedHistoryPush = (path) => {
                //   console.log('pages....');
                //   history.push(path); // parent navigates
                // };
            }
            
            const hasValidParams =
              params != null &&
              typeof params === 'object' &&
              Array.isArray(params) === false;
            const pagesWithParams =
              hasValidParams && isSet(response?.data?.pages, null) !== null
                ? { ...response.data.pages, params }
                : response?.data?.pages;

            // Merge outputVariables into collections object (consistent with existing pattern)
            const collectionsWithOutput = {
              ...response.data,
              ...(pagesWithParams ? { pages: pagesWithParams } : {}),
              ...(Object.keys(outputVariables).length
              ? { outputVariables: { ...outputVariables } }
              : {})
            };

            if (onload === true && pType !== 'RENDER') {
              dispatch(loadPageConfigCollectionSilentAction(
                collectionsWithOutput,
                searchBy,
                response?.data?.configuration_api_name
              ));
            } else {
              dispatch(loadPageConfigCollectionAction(
                collectionsWithOutput,
                searchBy,
                response?.data?.configuration_api_name
              ));
            }
            if (shouldNavigateSameWindow === true && history) {
              history.push(`/pages/${responseData?.configuration_api_name}${publicQuery}`);
            }
        }else{
          const variableResponse = await PagesServices.getConfigVariablesList(responseData?.id, responseData?.configuration_api_name);
          let inputVariables = [];
          let outputVariables = [];
          let windowsIdsForWinVariable = [];
          variableResponse?.data?.content.forEach((vari)=>{
            if(vari.is_request===true){
              inputVariables.push({
                ...vari,type:vari.fieldtype_name
              });
              if(isSet(vari.window_field_id_path,null)!==null){
                windowsIdsForWinVariable.push(vari.window_id);
              }
            }else{
              outputVariables.push({
                ...vari,type:vari.fieldtype_name
              });
            }
          });
          const winIds = [...new Set(windowsIdsForWinVariable)];

          console.log('windowsIdsForWinVariable',winIds);

          // Fetch lookup-layouts metadata for each window id and store in reducer
          let windowVariableList = {};
          for (const windowId of winIds) {
            try {
              const lookupResponse = await PagesServices.getLookupLayoutsByWindowId(windowId);
              if (lookupResponse && lookupResponse.code === 200) {
                windowVariableList[windowId] = lookupResponse.data;
              }
            } catch (e) {
              // fail silently for individual window ids
            }
          }
          if (Object.keys(windowVariableList).length > 0) {
            dispatch(setWindowVariableListAction(windowVariableList));
          }

          dispatch(setResourcesListByTypesAction(inputVariables,outputVariables));
          const hasValidParams =
            params != null &&
            typeof params === 'object' &&
            Array.isArray(params) === false;
          const responseWithParams =
            hasValidParams && isSet(response?.data?.pages, null) !== null
              ? { ...response.data, pages: { ...response.data.pages, params } }
              : response.data;
          queueMicrotask(() => {
            const creator = onload === true && pType !== 'RENDER'
              ? loadPageConfigCollectionSilentAction
              : loadPageConfigCollectionAction;
            dispatch(creator(responseWithParams,searchBy,response?.data?.configuration_api_name));
          });
          
          // Execute API automatically for non-DIRECT config types with default/empty payload
          // let executeOutputVariables = {};
        
          // Merge outputVariables into collections object (consistent with DIRECT type pattern)
          // const collectionsWithOutput = {
          //   ...response.data,
          //   ...(Object.keys(executeOutputVariables).length > 0
          //     ? { outputVariables: { ...executeOutputVariables } }
          //     : {})
          // };
          
          // dispatch(loadPageConfigCollectionAction(collectionsWithOutput,searchBy,response?.data?.configuration_api_name));
        
          const automationPageDetails = response?.data;
          const fromMapping = isSet(automationPageDetails?.from_page_mapping,[]);

          const updatePayload = fromMapping;

          const toMapping = isSet(automationPageDetails?.to_page_mapping,[]);
          // console.log('responseData-data-onload',onload,updatePayload);
          if(onload===false){
            executeAPI(
              automationPageDetails,
              updatePayload,
              toMapping,
              false,
              !!automationPageDetails?.is_same_page,
              history,
              dispatch,
              searchBy,
              params,
              getState
            );
          }
        }
        if (responseData?.config_type==="DIRECT" && params != null && typeof params === 'object' && response?.data?.configuration_api_name) {
          // console.log('params-testing...',response.data.configuration_api_name,{ ...isSet(response?.data?.pages,{}) ,params });
          queueMicrotask(() => {
            dispatch(updatePageDataByKeyAction(response.data.configuration_api_name, 'pages', { ...isSet(response?.data?.pages,{}) ,params }));
          });
          
        }
      }
      // console.log('response',response);
      // dispatch({ type: "API_SUCCESS", payload: response.data });
    } catch (error) {
      // dispatch({ type: "API_FAILURE", error });
    }
  };
};
export const loaderDispatch = (dispatch,bool) => {
  if(dispatch){
    dispatch({
      type: "LOADER",
      bool: bool
    });
  }
}

export const executeAPI = (automationPageDetails, updatePayload, toMapping, isbackgroundProcess = false, isSamePage = false, history, dispatch = null, searchBy = null, params = {}, getState = null) => {
  const url = `pageconfig/${automationPageDetails.id}/pages-config-execute`;
  try {
      loaderDispatch(dispatch,true);
      const resourcesList = getState?.()?.PagesReducer?.resourcesList;
      const postPayload = buildPagesConfigExecutePayload({
        fromMapping: updatePayload,
        resourcesList,
        automationType: automationPageDetails?.automation_type,
        params,
      });
      http.POST(url, postPayload)
          .then(async (response) => {
              const responseData = response.data;
              if (responseData.code === 200) {
                  const resData = responseData?.data;
                  if (!resData) {
                    if (dispatch) dispatch(failMessage(responseData?.message || "No data returned"));
                    loaderDispatch(dispatch,false);
                    return;
                  }
                  let outputResponse = {};
                  let variables = isSet(resData?.variables, []);
                  if (automationPageDetails?.automation_type === 'API') {
                      isSet(resData, []).forEach((rData) => {
                          variables = [...variables, ...isSet(rData.variables, [])];
                      })
                  }
                  try {
                      variables.forEach((v) => {
                          outputResponse = {
                              ...outputResponse,
                              [isSet(v.api_name, v.apiName)]: v
                          }
                      });
                  } catch (e) {}

                  // console.log('outputResponse',outputResponse);
                  //  this.props.Loader(false);
                  // console.log('variables',variables);
                  // let outputErrorMsg = outputResponse?.Error_messages?.value;
                  // if ((responseData.messages !== undefined && responseData.messages.length > 0) || isSet(outputErrorMsg, []).length > 0) {
                  //   let errorMessageList = isSet(responseData.messages, isSet(outputErrorMsg, []), 'ARRAY');
                  //   // console.log('errorMessageList',errorMessageList);
                  //   // this.props.setErrorListAction(errorMessageList);
                  //   if (!this.props.isErrorModalOpen) {
                  //                 this.props.Loader(false);
                  //     // this.props.showErrorDetailsAction();
                  //   }
                  // }
                  // console.log('automationPageDetails',automationPageDetails?.configuration_api_name);
                  let isConditionTrue = false;
                  const safeToMapping = isSet(toMapping, []);
                  for (let i = 0; i < safeToMapping.length; i++) {
                      const toMap = safeToMapping[i];
                      const isTrue = evaluatePagesMessageCondition(toMap?.condition, outputResponse);
                      if (!isTrue) continue;
                      isConditionTrue = true;
                      if (isToPageRedirectMode(toMap)) {
                          const didRedirect = resolveAndNavigateRedirect({
                              redirectConfig: toMap.redirect,
                              variables,
                              history,
                          });
                          if (didRedirect) {
                              loaderDispatch(dispatch, false);
                              return;
                          }
                          continue;
                      }
                      const valuesArray = variables;
                      let toFieldMapping = isSet(toMap?.field_mappings, []).map((mField) => {
                          const result = valuesArray?.find((item) => item.id === mField.automation_variable_id);
                          if (result) {
                              let parsedValue = isSet(result.value, '');
                              try {
                                  if (typeof result.value === 'string') {
                                      parsedValue = JSON.parse(result.value);
                                  }
                              } catch (e) {}
                              return { ...mField, value: parsedValue };
                          }
                          return mField;
                      });
                      let toFieldMappingOutputs = {};
                      try {
                          toFieldMapping.forEach((v) => {
                              toFieldMappingOutputs = {
                                  ...toFieldMappingOutputs,
                                  [v.pages_variable_name]: v?.value
                              };
                          });
                      } catch (e) {}
                      if (!isbackgroundProcess) {
                          let pageId = toMap?.page_id;
                          if (isSamePage && typeof getState === 'function') {
                              const configKey = automationPageDetails?.configuration_api_name;
                              const cachedPageId =
                                  getState()?.PagesReducer?.pageFlows?.pageData?.[configKey]?.pages?.id;
                              if (cachedPageId) {
                                  pageId = cachedPageId;
                              }
                          }
                          if (dispatch) {
                              fetchPageDetails(
                                  pageId,
                                  automationPageDetails?.configuration_api_name,
                                  toFieldMappingOutputs,
                                  dispatch,
                                  history,
                                  null,
                                  null,
                                  params,
                                  isSamePage,
                                  getState
                              );
                          }
                      }
                      break;
                  }
                  if (!isConditionTrue) {
                    loaderDispatch(dispatch,false);
                  }

                  // console.log('outputResponse',JSON.stringify(outputResponse));

              } else {
                loaderDispatch(dispatch,false);
              }
          }, (error) => {
            loaderDispatch(dispatch,false);
              console.log(error);
              //  this.setState({
              //   isMappingDDLoading:false
              // })
          })
  } catch (error) {
      console.error("Error in executeAPI:", error);
  }
}

export const restorePageFlowsAction = ()=>{
  return{
    type:RESTORE_PAGE_FLOWS,
    payload:{}
  }
}



export const toPagesRulesCheck = (rules,outputResponse)=>{

  let validationResult ='(true===true)';
  if(rules.length>0){
    validationResult+=' && (';
  }
  rules.forEach((rule,ruleIndex)=>{
    const conditionField = {
        isExist:isSet(outputResponse['pages_message'],null)!==null?true:false,
        field:{type:'TextInput',...outputResponse['pages_message'],selectedValue:outputResponse['pages_message']?.value},
        selectedValue:outputResponse['pages_message']?.value}
    if(conditionField.isExist===true){
      if(ruleIndex>0){
        if(isSet(rule.logical_operator,'')==='AND'){
          validationResult+=' &&';
        }else if(isSet(rule.logical_operator,'')==='OR'){
          validationResult+=' || ';
        }
      }
    //   console.log('filter',isSet(rule.filter_name,'equal to'));
      validationResult+=' (true==='+conditionRulesChecking(
        conditionField,
        {values:rule.value,filter:isSet(rule.filter_name,'is not empty')})+' )';
        
    }else{
      if(ruleIndex>0){
        validationResult+=' &&';
      }
      validationResult+='(true===false)';
    }
  });
  if(rules.length>0){
    validationResult+=')';
  }
//   console.log('conditionField',validationResult);
  try{
    if(eval("("+validationResult+")")){
      return true;
    }
  }catch(e){

  }
  return false;
}
export const loadPageConfigCollectionAction =(collections,searchBy,configKey)=>{
  // console.log(" collect ---" , collections , searchBy , configKey);
  
  return{
    type:LOAD_CONFIG_COLLECTION,
    payload:{
          collections:collections,
          identifer:searchBy,
          configKey:configKey
        }
  }
}

export const loadPageConfigCollectionSilentAction =(collections,searchBy,configKey)=>{
  return{
    type:LOAD_CONFIG_COLLECTION_SILENT,
    payload:{
          collections:collections,
          identifer:searchBy,
          configKey:configKey
        }
  }
}

export const setActiveConfigPagesAction = (type,page)=>{
  return{
    type:SET_ACTIVE_CONFIG_PAGE,
    payload:{
      pageDesignType:type,
      pageConfigKey:page
    }
  }
}

export const removeActivePopupPageAction =(configKey)=>{
  return{
    type:REMOVE_ACTIVE_POPUP_PAGE,
    payload:{
      removingConfigKey:configKey
    }
  }
}

export const updatePageFlowsDataAction = (apiName,key,data)=>{
  return{
    type:UPDATE_PAGE_FLOWS_DATA,
    payload:{
      configApiName:apiName,
      pageDataKey:key,
      pageDataValue:data
    }
  }
}
// END OF RENDER PAGES BLOCK

/**
 * Shallow-merge page data for a given config key into pageFlows.pageData.
 * If targetKey (e.g. 'pages') is passed, the patch is merged into pageData[configKey][targetKey],
 * copying existing nested data first. Otherwise the patch is merged into pageData[configKey].
 */
export const updatePageDataByKeyAction = (configKey,targetKey = null, patch) => ({
  type: UPDATE_PAGE_DATA_BY_KEY,
  payload: {
    configKey,
    targetKey,
    patch
  }
});


